module.exports = __webpack_public_path__ + "img/hs_1@2x.f2e740c9.png";